import { Popover } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';

interface ColorHeaderProps {
  fillColor: string;
  textColor: string;
  name: string;
  text?: string;
}

export default function ColorHeader({ textColor, text, fillColor, name }: ColorHeaderProps) {
  return (
    <div className="flex items-center mb-4 p-2">
      <div className={'flex w-[35%]'}>
        <span className="whitespace-nowrap text-left pr-2">{name}</span>
      </div>

      <div className="flex w-[65%] gap-5">
        <div className="flex justify-center items-center bg-[#fef4ea] text-black  p-2 flex-1 text-center border border-gray-300 rounded w-[120px]">
          <span>{fillColor}</span>
        </div>

        <div className="flex justify-center items-center bg-[#fef4ea] text-black  p-2 flex-1 text-center border border-gray-300 rounded w-[120px]">
          <span>{textColor}</span>
          {text && (
            <Popover content={text} trigger="click" overlayStyle={{ width: 400 }}>
              <InfoCircleOutlined className="cursor-pointer ml-2 text-black" />
            </Popover>
          )}
        </div>
      </div>
    </div>
  );
}
